export enum CollectionType {
  DisneyFan = 'disney-fan',
  TattyTeddyCollector = 'tatty-teddy-collector',
  CathKidstonFan = 'cath-kidston-fan',
  ChocolateLover = 'chocolate-lover',
  FootballFan = 'football-fan',
  ProudGardener = 'proud-gardener',
  Gamer = 'gamer',
  PetParent = 'pet-parent',
  WellnessObsessed = 'wellness-obsessed',
}

export const collectionTypes: CollectionType[] = [
  CollectionType.DisneyFan,
  CollectionType.TattyTeddyCollector,
  CollectionType.CathKidstonFan,
  CollectionType.ChocolateLover,
  CollectionType.FootballFan,
  CollectionType.ProudGardener,
  CollectionType.Gamer,
  CollectionType.PetParent,
  CollectionType.WellnessObsessed,
]

export enum CollectionTileContext {
  CrossSell = 'cross_sell',
}

export enum CollectionTileMission {
  Birthday = 'occasion-birthday',
}

export type CollectionTileConfig = {
  title: string
  backgroundColor: string
  image: string
  path: string
}

export type CollectionHeader = {
  title: string
  description: string
  image: string
}

export type CollectionConfig = {
  promotionId: string
  missionId: string
  mission: string
  header: CollectionHeader
  tile: CollectionTileConfig
}

export type CollectionTile = CollectionTileConfig & {
  path: string
}

export type CmsContentWithCollection = {
  offer: string
  title: string
  description: string | null
  breadcrumbsItems: { label: string; url: string }[]
  header: CollectionHeader
}

export type PageMeta = {
  title: string
  description: string
  canonicalSubPath: string
  noIndex: boolean
  openGraph: {
    url: string
    title: string
    description: string
    image: {
      url: string
    }
    locale: string
    siteName: string
    type: string | null
  }
  structuredData: {
    json: string
  }[]
}

export type SearchParameters = {
  searchTerm: string
  departments: DepartmentsEnum[]
  searchFilters: SearchFilters
  preAppliedFacets: string[]
  sponsoredProducts: SponsoredProductInput[]
  promotionId?: string
}

export type SearchFilters = {
  promotionId?: string
  variants?: number[]
  facets: SearchFiltersFacet[]
}

export type SearchFiltersFacet = {
  group: string
  facetKey: string
  userApplied?: boolean
}

export type SponsoredProductInput = {
  internallyPromoted: boolean
  productKey: string
}

export enum DepartmentsEnum {
  ACRYLICS = 'ACRYLICS',
  ALCOHOL_GIFTS = 'ALCOHOL_GIFTS',
  ALL_CARDS = 'ALL_CARDS',
  ALL_FLOWERS_AND_PLANTS = 'ALL_FLOWERS_AND_PLANTS',
  ALL_GIFTS = 'ALL_GIFTS',
  ARENA_POSTAL_FLOWERS = 'ARENA_POSTAL_FLOWERS',
  BALLOONS = 'BALLOONS',
  BEAUTY = 'BEAUTY',
  CALENDAR_PHOTOBOX = 'CALENDAR_PHOTOBOX',
  CANVASES = 'CANVASES',
  CASES = 'CASES',
  DIGITAL_GIFTS = 'DIGITAL_GIFTS',
  DIGITAL_GIFT_CARDS = 'DIGITAL_GIFT_CARDS',
  FLOWERS = 'FLOWERS',
  FOOD_GIFTS = 'FOOD_GIFTS',
  FRAMES = 'FRAMES',
  GADGETS_AND_NOVELTIES = 'GADGETS_AND_NOVELTIES',
  GIFTS_FOR_HOME = 'GIFTS_FOR_HOME',
  GIFT_BOXES = 'GIFT_BOXES',
  GIFT_EXPERIENCES = 'GIFT_EXPERIENCES',
  GIFT_VOUCHERS = 'GIFT_VOUCHERS',
  GREETING_CARDS = 'GREETING_CARDS',
  GUERNSEY_POSTAL_FLOWERS = 'GUERNSEY_POSTAL_FLOWERS',
  INVITATIONS_AND_ANNOUNCEMENTS = 'INVITATIONS_AND_ANNOUNCEMENTS',
  JEWELLERY_AND_ACCESSORIES = 'JEWELLERY_AND_ACCESSORIES',
  LETTERBOX_GIFTS = 'LETTERBOX_GIFTS',
  MINI_CARDS = 'MINI_CARDS',
  MUGS = 'MUGS',
  NON_CUSTOMISABLE_GIFTS = 'NON_CUSTOMISABLE_GIFTS',
  PARTY = 'PARTY',
  PLANTS = 'PLANTS',
  SOFT_TOYS = 'SOFT_TOYS',
  STATIONERY_AND_CRAFT = 'STATIONERY_AND_CRAFT',
  TOYS_AND_GAMES = 'TOYS_AND_GAMES',
  TSHIRTS = 'TSHIRTS',
  WALL_ART = 'WALL_ART',
  WEDDING_STATIONERY = 'WEDDING_STATIONERY',
}
